export type EventKey = {
    "key": string,
    "keyCode": number,
    "which": number,
    "code": string,
    "location"?: number,
    "altKey"?: boolean,
    "ctrlKey"?: boolean,
    "metaKey"?: boolean,
    "shiftKey"?: boolean,
    "repeat"?: boolean
}

export type KeyMapType = {
    Enter: EventKey,
    Escape: EventKey,
    Space: EventKey,
    Tab: EventKey,
    ArrowDown: EventKey,
    ArrowUp: EventKey,
    ArrowLeft: EventKey,
    ArrowRight: EventKey,
    ShiftLeft: EventKey,
    ShiftRight: EventKey,
    Home: EventKey,
    End: EventKey,
}

export const KEY_MAPS: KeyMapType = {
    Enter: {
        "key": "Enter",
        "keyCode": 13,
        "which": 13,
        "code": "Enter"
    },
    Escape: {
        "key": "Escape",
        "keyCode": 27,
        "which": 27,
        "code": "Escape"
    },
    Space: {
        "key": " ",
        "keyCode": 32,
        "which": 32,
        "code": "Space"
    },
    Tab: {
        "key": "Tab",
        "keyCode": 9,
        "which": 9,
        "code": "Tab"
    },
    ArrowDown: {
        "key": "ArrowDown",
        "keyCode": 40,
        "which": 40,
        "code": "ArrowDown"
    },
    ArrowUp: {
        "key": "ArrowUp",
        "keyCode": 38,
        "which": 38,
        "code": "ArrowUp"
    },
    ArrowLeft: {
        "key": "ArrowLeft",
        "keyCode": 37,
        "which": 37,
        "code": "ArrowLeft"
    },
    ArrowRight: {
        "key": "ArrowRight",
        "keyCode": 39,
        "which": 39,
        "code": "ArrowRight"
    },
    ShiftLeft: {
        "key": "Shift",
        "keyCode": 16,
        "which": 16,
        "code": "ShiftLeft",
        "shiftKey": true,
    },
    ShiftRight: {
        "key": "Shift",
        "keyCode": 16,
        "which": 16,
        "code": "ShiftRight",
        "shiftKey": true
    },
    Home: {
        "key": "Home",
        "keyCode": 36,
        "which": 36,
        "code": "Home"
    },
    End: {
        "key": "End",
        "keyCode": 35,
        "which": 35,
        "code": "End"
    },
}